/**
 * app 唯一标记
 */
enum AppKey {
    网络 = 'Kingxunlian.Network',
    用户管理 = 'Kingxunlian.UserMgmt',
    公司信息 = 'Kingxunlian.CompanyInfo',
    集团资料 = 'Kingxunlian.GroupInfo',
    部门管理 = 'Kingxunlian.DeptMgmt',
    应用管理 = 'Kingxunlian.AppMgmt',
    帮助中心 = 'Kingxunlian.Help',
    // 商品 = 'Kingxunlian.TaxCode',
    商品 = 'Kingxunlian.ProcProdMgmt',
    任务中心 = 'Kingxunlian.TaskCenter',
    消息 = 'Kingxunlian.Message',
    单据 = 'Kingxunlian.Document',
    APP商店 = 'Kingxunlian.AppStore',
    审计日志 = 'Kingxunlian.AuditLog',
    切换公司 = 'Kingxunlian.CompanySwitch',
    角色管理 = 'Kingxunlian.RoleMgmt',
    开发测试 = 'debugging',
}

export default AppKey;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/AppKey/index.ts